import React from "react";
import { ArrowRight, Truck, ShieldCheck, Snowflake, Wrench, Shredder, Building2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AdditionalServicesOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="zusatzleistungen-im-überblick" className="py-24 bg-background relative overflow-hidden" ref={ref}>
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-4">
            Weitere Dienstleistungen
          </h2>
          <p className="text-lg text-muted-foreground">Wir bieten mehr als nur Sauberkeit – entdecken Sie unsere spezialisierten Zusatzleistungen für Ihre Immobilie.</p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 max-w-5xl mx-auto">
          {}
          <Link to="/AdditionalServicesPage" className={`group block h-full transition-all duration-700 delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <Card className="h-full border-border bg-background hover:bg-muted transition-colors duration-300 overflow-hidden relative">
              <CardHeader className="pb-4">
                <div className="flex items-start justify-between">
                  <div className="p-3 bg-primary/5 rounded-lg text-primary group-hover:bg-primary/10 transition-colors">
                    <Truck className="w-8 h-8" />
                  </div>
                  <div className="p-2 rounded-full bg-transparent group-hover:bg-background/50 transition-colors">
                    <ArrowRight className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors -translate-x-2 opacity-0 group-hover:translate-x-0 group-hover:opacity-100" />
                  </div>
                </div>
                <CardTitle className="text-2xl mt-4 group-hover:text-primary transition-colors">
                  Mobile Aktenvernichtung
                </CardTitle>
                <CardDescription className="text-base mt-2">Sichere Datenvernichtung direkt bei Ihnen vor Ort</CardDescription>
              </CardHeader>
              <CardContent>
                
                <div className="mt-8 flex items-center text-sm font-medium text-primary opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
                  Mehr erfahren <ArrowRight className="ml-1 w-4 h-4" />
                </div>
              </CardContent>
            </Card>
          </Link>

          {}
          <Link to="/AdditionalServicesPage" className={`group block h-full transition-all duration-700 delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <Card className="h-full border-border bg-background hover:bg-muted transition-colors duration-300 overflow-hidden relative">
              <CardHeader className="pb-4">
                <div className="flex items-start justify-between">
                  <div className="p-3 bg-primary/5 rounded-lg text-primary group-hover:bg-primary/10 transition-colors">
                    <Building2 className="w-8 h-8" />
                  </div>
                  <div className="p-2 rounded-full bg-transparent group-hover:bg-background/50 transition-colors">
                    <ArrowRight className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors -translate-x-2 opacity-0 group-hover:translate-x-0 group-hover:opacity-100" />
                  </div>
                </div>
                <CardTitle className="text-2xl mt-4 group-hover:text-primary transition-colors">
                  Regionale Objekt-Services
                </CardTitle>
                <CardDescription className="text-base mt-2">Umfassende Betreuung für Ihre Liegenschaften</CardDescription>
              </CardHeader>
              <CardContent>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
                  
                  
                </div>
                <div className="mt-8 flex items-center text-sm font-medium text-primary opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
                  Mehr erfahren <ArrowRight className="ml-1 w-4 h-4" />
                </div>
              </CardContent>
            </Card>
          </Link>
        </div>
      </div>
    </section>;
}